import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=e3efa4dc"
var script = {}
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=e3efa4dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports